import { BrowserRouter, Routes, Route, Link, NavLink } from 'react-router-dom';
import Home from './pages/Home';
import GameDetail from './pages/GameDetail';
import NotFound from './pages/NotFound';
import './index.css';

export default function App() {
    return (
        <BrowserRouter>
            <header className="gw-nav">
                <div className="gw-nav-inner">
                    <Link to="/" className="gw-brand">GamesWeb</Link>
                    <nav className="gw-links">
                        <NavLink to="/" className={({isActive})=>isActive?'gw-link active':'gw-link'}>Domů</NavLink>
                    </nav>
                </div>
            </header>
            <main className="gw-main">
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/game/:slug" element={<GameDetail />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </main>
            <footer className="gw-foot">
                <div className="gw-foot-inner">© GamesWeb</div>
            </footer>
        </BrowserRouter>
    );
}
